import * as breakpoints from "./breakpoints";

export const mediaMinExtraSmall = {
  minWidth: breakpoints.extraSmall,
};
export const mediaMaxExtraSmall = {
  maxWidth: breakpoints.extraSmall - 1,
};

export const mediaMinSmall = {
  minWidth: breakpoints.small,
};
export const mediaMaxSmall = {
  maxWidth: breakpoints.small - 1,
};

export const mediaSmall = {
  minWidth: breakpoints.extraSmall,
  maxWidth: breakpoints.small - 1,
};

export const mediaMinMedium = {
  minWidth: breakpoints.medium,
};
export const mediaMaxMedium = {
  maxWidth: breakpoints.medium - 1,
};

export const mediaMedium = {
  minWidth: breakpoints.small,
  maxWidth: breakpoints.medium - 1,
};

export const mediaMinLarge = {
  minWidth: breakpoints.large,
};
export const mediaMaxLarge = {
  maxWidth: breakpoints.large - 1,
};

export const mediaLarge = {
  minWidth: breakpoints.medium,
  maxWidth: breakpoints.large - 1,
};
